import React from "react";
import { Row, SelectField, byClientTitle, byLabelValue } from "./fields";

/**
 * Where in the client's org chart this user sits. Title only for an
 * AccountAdmin, who has no branch or department.
 */
const AnalyticsProfile = ({
  form,
  clientUserTitle,
  branches,
  departments,
  showTitle,
  showBranchDepartment,
}: {
  form: any;
  clientUserTitle: any[];
  branches: any[];
  departments: any[];
  showTitle: boolean;
  showBranchDepartment: boolean;
}) => {
  if (!showTitle && !showBranchDepartment) return null;

  return (
    <Row>
      {showTitle && (
        <SelectField
          id="client_title"
          label="User Title"
          form={form}
          options={clientUserTitle}
          {...byClientTitle}
        />
      )}
      {showBranchDepartment && (
        <>
          <SelectField
            id="client_branch"
            label="Client Branch"
            form={form}
            options={branches}
            {...byLabelValue}
          />
          <SelectField
            id="client_department"
            label="Client Department"
            form={form}
            options={departments}
            {...byLabelValue}
          />
        </>
      )}
    </Row>
  );
};

export default AnalyticsProfile;
